import * as React from 'react';
import styled from 'styled-components';

interface IconButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
	iconClass: string;
}

export default function IconButton(props: React.PropsWithChildren<IconButtonProps>) {
	const { iconClass, children, ...rest } = props;

	return (
		<ButtonWrapper {...rest}>
			<i className={iconClass} />
			{children}
		</ButtonWrapper>
	);
}

const ButtonWrapper = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;

	i {
		margin-right: 1rem;
	}
`;
